import {
  getSubjects,
  getMediums,
  getCities,
  getDistrictCities,
  getClassTypes,
  getEduLevelSubjects,
} from '../api/masterData.api';

export const fetchSubjects = async () => {
  const res = await getSubjects();
  return res.data;
};

export const fetchEduLevelSubjects = async () => {
  const res = await getEduLevelSubjects();
  return res.data;
};

export const fetchMediums = async () => {
  const res = await getMediums();
  return res.data;
};

export const fetchCities = async () => {
  const res = await getCities();
  return res.data;
};

export const fetchDistrictCities = async () => {
  const res = await getDistrictCities();
  return res.data;
};

export const fetchClassTypes = async () => {
  const res = await getClassTypes();
  return res.data;
};
